import React__default from 'react';
import classNames from './../external_lib/classnames/index.js';

function Card(_a) {
    var id = _a.id, children = _a.children, classes = _a.classes, onClick = _a.onClick;
    return (React__default.createElement("div", { className: classNames('card', classes), onClick: onClick, id: id }, children));
}

export { Card as default };
//# sourceMappingURL=Card.js.map
